module.exports = __webpack_public_path__ + "static/media/help.45786220.svg";